// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rotate {
    width: 50px;
    animation: rotation 1s infinite linear;
}

.cls-1 {
    /*fill: none;*/
    stroke-width: 0;
}

.cls-2 {
    clip-path: url(#clippath-1);
}

.cls-3 {
    clip-path: url(#clippath);
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/css/loading.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".rotate {\n    width: 50px;\n    animation: rotation 1s infinite linear;\n}\n\n.cls-1 {\n    /*fill: none;*/\n    stroke-width: 0;\n}\n\n.cls-2 {\n    clip-path: url(#clippath-1);\n}\n\n.cls-3 {\n    clip-path: url(#clippath);\n}\n\n@keyframes rotation {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(359deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
